import React from 'react'

const Maintenance = () => {
  return (
    <>
        <div className='w-screen h-screen flex flex-col xl:flex-row xl:justify-around justify-center items-center'>
            <div className='flex flex-col w-1/2 '>
                <span className='text-md lg:text-2xl xl:text-4xl font-bold text-center'>Mohon Maaf, </span>
                <span className='text-md lg:text-2xl xl:text-4xl font-bold text-center'>Sistem sedang dalam perbaikan</span>
                <span className='text-xs md:text-lg xl:text-2xl font-normal mt-2 text-center'>Mohon maaf atas ketidaknyamanannya</span>
                <span className='text-sm lg:text-lg  font-semibold mt-4 text-center'></span>
            </div>
            <img className=' h-auto w-1/2' src='/maintenance.jpg' alt="maintenance"/>
        </div>
    </>
  )
}

export default Maintenance